export default class BPNachbestellenBeginnenRequest {
  bestellungId: string
}
